import { Select, BrandSelect } from 'components/Select'
import { RangePicker } from 'components/DatePicker'
import { IOptions } from 'components/Select/help'
import SingleInput from 'components/SingleInput'
import { Loading } from '@rushable/icons'

import { TFilterForm, statusOptions, filterTypeOptions } from '../helpers/constant'

export type TSearchFilterProps = {
  autoLoading: boolean
  locationOptions: IOptions[]
  setLocationOptions: (arg1: IOptions[]) => void
  filterForm: TFilterForm
  handleFormChange: (type: string, value: string | number) => void
}

export default function SearchFilter({
  autoLoading,
  locationOptions,
  setLocationOptions,
  filterForm,
  handleFormChange,
}: TSearchFilterProps) {
  const { status, brand_name, location_id, type, order_id, begin_time, end_time } =
    filterForm
  const onChange = (item: any, rest: any) => {
    const { locations } = rest
    handleFormChange('brand_name', item)
    if (locations && locations.length > 0) {
      setLocationOptions(
        [{ value: '', label: 'All Locations' }].concat(
          locations.map((loc: any) => {
            return {
              label: loc.name,
              value: loc.id,
            }
          }),
        ),
      )
    }
  }

  return (
    <div className='mb-8 mr-4 flex items-center justify-between'>
      <div className='flex space-x-4'>
        <Select
          className='w-216'
          options={statusOptions}
          value={status}
          onChange={value => handleFormChange('status', value)}
        />
        <BrandSelect
          className='w-216'
          placeholder='Search'
          value={brand_name}
          apiType='orders'
          isShowLocation={false}
          isShowAllBrands={false}
          onChange={onChange}
        />
        {brand_name && brand_name !== 'All Brands' ? (
          <Select
            key={location_id}
            className='w-216'
            options={locationOptions}
            value={location_id}
            onChange={value => handleFormChange('location_id', value)}
          />
        ) : null}
        <Select
          className='w-216'
          options={filterTypeOptions}
          value={type}
          onChange={value => handleFormChange('type', value)}
        />
        <SingleInput
          className='w-216'
          value={order_id}
          name='SELECT_ORDER_ID'
          placeholder='Order ID'
          onChange={e => handleFormChange('order_id', e.target.value)}
        />
        <RangePicker
          className='w-256'
          range={{
            startDate: begin_time,
            endDate: end_time,
          }}
          onChange={(e: any) => {
            handleFormChange('dates', e)
          }}
        />
      </div>
      {autoLoading && <Loading />}
    </div>
  )
}
